import { Checkbox as AntCheckbox } from "antd";

export default function Checkbox (props:any) {

  return (
    <AntCheckbox {...props} checked={props.checked === undefined ? !!props.value : props.checked} onChange={(e) => props.onChange(e.target.checked)}>
        {props.children}
    </AntCheckbox>
  )  
}